import React__default from 'react';
import { Badge, Box } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { classes } from '../../Basket/BasketToggler/index.styled.js';
import DefaultIcon from '../../DefaultIcon/index.js';
import KButtonAction from '../../KButtons/KButtonAction/index.js';

var BusinessFilterToggler = function (_a) {
    var _b = _a.count, count = _b === void 0 ? 0 : _b, onToggle = _a.onToggle, active = _a.active, className = _a.className, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c, id = _a.id, _d = _a.testId, testId = _d === void 0 ? "businessFilterToggler" : _d, sx = _a.sx;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(KButtonAction, { className: clsx(active && "active", className, "BusinessFilterToggler"), onClick: onToggle, "data-testid": testId, title: t("components.businessFilter.businessFilterToggler.title"), id: id, "aria-expanded": active ? "true" : "false", sx: sx },
        React__default.createElement(Badge, { className: classes.count, sx: {
                "& .MuiBadge-badge": {
                    border: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
                    backgroundColor: function (theme) { return theme.palette.common.white; },
                    color: function (theme) { return theme.palette.primary.main; }
                }
            }, max: 99, badgeContent: count },
            React__default.createElement(KIcon, { fontSize: "small", className: "fa-solid fa-sliders" }),
            React__default.createElement(Box, { sx: { display: "none" }, className: "sr-only" }, t("components.businessFilter.businessFilterToggler.help.title")))));
};

export { BusinessFilterToggler as default };
//# sourceMappingURL=index.js.map
